import { render, staticRenderFns } from "./ModalImages.vue?vue&type=template&id=32d8a4de&scoped=true&lang=html"
import script from "./ModalImages.vue?vue&type=script&lang=js"
export * from "./ModalImages.vue?vue&type=script&lang=js"
import style0 from "./ModalImages.vue?vue&type=style&index=0&id=32d8a4de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d8a4de",
  null
  
)

export default component.exports